import PersonalInfo from './PersonalInfo';
import OrderHistory from './OrderHistory';
import React, { Fragment, useEffect, useState } from 'react';
import RecommendationsContainer from './RecommendationsContainer';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ExistingRecommendations from './ExistingRecommendations';
import { get } from '../../../../Services/http';
import { translate } from '../../../../Services/translation';
import SubscriptionContainer from './SubscriptionContainer';
import ExistingSubscription from './ExistingSubscription';

const CustomerDetailsContainer = () => {     
    const [customerId, setcustomerId] = useState('');     
    const [searchParams] = useSearchParams();  
    const [addRecommendation, setaddRecommendation] = useState(false); 
    const [existingRecommendations, setexistingRecommendations] = useState([]);
    const [recommendationToEdit, setrecommendationToEdit] = useState({});
    const [editClicked, seteditClicked] = useState(false);       

    const [addSubscription, setaddSubscription] = useState(false); 
    const [existingSubscription, setexistingSubscription] = useState([]);
    const [upcomingSubscription, setupcomingSubscription] = useState([]);
    const [subscriptionToEdit, setsubscriptionToEdit] = useState({});
    const [editClickedSubscription, seteditClickedSubscription] = useState(false); 
    
    const [subscriptionPaymentMethods, setsubscriptionPaymentMethods] = useState([]);
    const [clinicalExaminationPrice, setclinicalExaminationPrice] = useState(0);
    const [disableReactivateFromPause, setdisableReactivateFromPause] = useState(false);
     
    useEffect(() => {             
        const customerIdParam = searchParams.get('Id');   
        setcustomerId(customerIdParam);
        if (customerIdParam) {
            getAndSetRecommendations(customerIdParam);
            getAndSetSubscription(customerIdParam);
        }         
    }, []);
    

    const getAndSetRecommendations = (customerId) => {
        get(`/api/customer/getrecommendations/${customerId}`)
            .then((response) => response.json())
            .then((result) => {
                setexistingRecommendations(result);
            });
    }
    const refreshExistingRecommendations = () => {
        getAndSetRecommendations(customerId);
        setaddRecommendation(false);
        seteditClicked(false);
    }

    const hideAddRecommendation = () => {        
        setaddRecommendation(false);
        seteditClicked(false);
    }

    const editClick = (recommendationId) => {
        seteditClicked(true);
        setaddRecommendation(true);
        setrecommendationToEdit(existingRecommendations.filter(a => a.recommendationIdentifier === recommendationId)[0]);
    }


    const getAndSetSubscription = (customerId) => {        
        get(`/api/customer/getsubscription/${customerId}`)
            .then((response) => response.json())
            .then((result) => {
                if (result.existingSubscription) {
                    setexistingSubscription(result.existingSubscription);
                } 
                if (result.upcomingSubscription) {
                    setupcomingSubscription(result.upcomingSubscription);
                }

                if (result.clinicalPartPrice) {
                    setclinicalExaminationPrice(result.clinicalPartPrice);
                }
                setsubscriptionPaymentMethods(result.paymentList);
                setdisableReactivateFromPause(result.disableReactivateFromPause);
            });
    }
    const refreshExistingSubscription = () => {
        getAndSetSubscription(customerId);
        setaddSubscription(false);
        seteditClickedSubscription(false);
    }

    const hideAddSubscription = () => {        
        setaddSubscription(false);
        seteditClickedSubscription(false);
    }

    const editClickSubscription = () => {
        seteditClickedSubscription(true);
        setaddSubscription(true);
        setsubscriptionToEdit(existingSubscription);
    }

    return(<Fragment>
            <PersonalInfo customerId={customerId}></PersonalInfo>
            <div className='admin-portal__recommendations-wrapper'>
                <div className='top-wrapper'>
                    <h5>
                        {translate('coptikk.adminportal.recommendations')}
                    </h5>
                    <a onClick={() => setaddRecommendation(true)}>{translate('coptikk.adminportal.recommendation.addrecommendation')}</a>
                </div>
                {addRecommendation && <RecommendationsContainer customerId={customerId} refresh={() => refreshExistingRecommendations()} 
                recommendationToEdit={editClicked ? recommendationToEdit : []} hideAddRceommendation={() => hideAddRecommendation()}></RecommendationsContainer>}
                <ExistingRecommendations customerId={customerId}  
                refresh={() => refreshExistingRecommendations()} editClick={(value) => editClick(value)} existingRecommendations={existingRecommendations}></ExistingRecommendations>
            </div>

            <div className='admin-portal__recommendations-wrapper'>
                <div className='top-wrapper'>
                    <h5>
                        {translate('coptikk.adminportal.subscription')}
                    </h5>
                    {existingSubscription.length <= 0 && <a onClick={() => setaddSubscription(true)}>{translate('coptikk.adminportal.subscription.addsubscription')}</a>}
                </div>
                {addSubscription && <SubscriptionContainer customerId={customerId} refresh={() => refreshExistingSubscription()} 
                subscriptionToEdit={editClickedSubscription ? subscriptionToEdit : []} hideAddSubscription={() => hideAddSubscription()}
                clinicalPartPrice={editClickedSubscription ? subscriptionToEdit.clinicalPartPrice : clinicalExaminationPrice}
                paymentList={subscriptionPaymentMethods}></SubscriptionContainer>}
                <ExistingSubscription customerId={customerId}  
                refresh={() => refreshExistingSubscription()} editClick={() => editClickSubscription()} 
                existingSubscription={existingSubscription} upcomingSubscription={upcomingSubscription} disableReactivateFromPause={disableReactivateFromPause}>
                </ExistingSubscription>
            </div>

            <OrderHistory customerId={customerId}></OrderHistory>
    </Fragment>)
}

export default CustomerDetailsContainer;